import { render, staticRenderFns } from "./FaseFenologicaManage.vue?vue&type=template&id=68c9c53e&scoped=true"
import script from "./FaseFenologicaManage.vue?vue&type=script&lang=js"
export * from "./FaseFenologicaManage.vue?vue&type=script&lang=js"
import style0 from "./FaseFenologicaManage.vue?vue&type=style&index=0&id=68c9c53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c9c53e",
  null
  
)

export default component.exports